import type { NavigationGuardNext, RouteLocationNormalized } from "vue-router";
import { useAuthStore } from "@/stores/auth";

export default async function requireAuth({
                                            next,
                                            to,
                                          }: {
  next: NavigationGuardNext;
  to: RouteLocationNormalized;
}) {
  try {
    const authStore = useAuthStore();

    if (!authStore.isLoggedIn) {
      try {
        localStorage.setItem("redirectPath", to.fullPath);
      } catch (e) {
        console.warn("localStorage not available, redirect path will not be preserved");
      }

      const redirectUri = encodeURIComponent(window.location.href);
      window.location.href = `${import.meta.env.VITE_AUTH_APP_URL}?redirect_uri=${redirectUri}`;
      return next(false);
    }
  } catch (error) {
    try {
      localStorage.setItem("redirectPath", to.fullPath);
    } catch (e) {
      console.warn("localStorage not available, redirect path will not be preserved");
    }

    const redirectUri = encodeURIComponent(window.location.href);
    window.location.href = `${import.meta.env.VITE_AUTH_APP_URL}?redirect_uri=${redirectUri}`;
  }

  return next();
}
